import React, { FC, ReactNode, useState } from 'react'
import { AppService } from '../../services'
import { AppState } from '../../stores/app'
import 'fixed-data-table-2/dist/fixed-data-table.css'
import './reporting.scss'
import { ReportStatusCode } from './enums/report-status-code'
import { Tabs } from 'antd'
import { PageHeader } from '@pushly/aqe/lib/components'
import { ReportingV2 } from './reporting'
import { SavedReports } from './saved-reports-table/saved-reports'
import { useService } from '@pushly/aqe/lib/hooks'
import { getPathEntityId } from '@pushly/aqe/lib/utils/get-path-entity-id'

type InsightsProps = {
    location?: Location
}

export const Insights: FC<InsightsProps> = ({ location, ...rest }) => {
    const appSvc = useService(AppService)
    const appState = useService(AppState)
    const [insightsStatus, setInsightsStatus] = useState<{ code?: ReportStatusCode; message?: ReactNode }>({})

    const pathOrgId = getPathEntityId('organization')
    const pathDomainId = getPathEntityId('domain')

    const tabProps: any = { ...rest }

    if (pathOrgId) {
        tabProps.level = 'org'
        tabProps.orgId = pathOrgId
    } else {
        tabProps.level = 'domain'
        tabProps.domainId = pathDomainId
    }

    let contextLevelName = appState.currentDomain?.displayName
    if (pathOrgId && appState.currentDomain?.accountId === pathOrgId) {
        contextLevelName = appState.currentDomain?.accountName
    }

    const currentTabKey = location?.hash?.replace('#', '')?.toLowerCase() || 'reporting'

    return (
        <div className="reporting-v2 page">
            <div className="report-display-wrapper">
                <PageHeader title="Insights" append={contextLevelName} onTitleSet={appSvc.customizeTabTitle} />
                <Tabs
                    size="small"
                    animated={{ inkBar: false, tabPane: false }}
                    tabPosition="top"
                    activeKey={currentTabKey}
                    onChange={(key) => appSvc.route(`${location?.pathname}#${key}`)}
                    destroyInactiveTabPane={true}
                >
                    <Tabs.TabPane key="reporting" tab="Reporting">
                        <ReportingV2
                            level={tabProps.level}
                            levelId={tabProps.level === 'org' ? tabProps.orgId : tabProps.domainId}
                        />
                    </Tabs.TabPane>

                    {tabProps.level === 'domain' && (
                        <Tabs.TabPane key="saved" tab="Saved Reports">
                            <SavedReports
                                defaultFilters={{
                                    search: 'what',
                                }}
                                location={location?.pathname}
                                onStatusUpdate={(status) => {
                                    setInsightsStatus(status)
                                }}
                            />
                            {insightsStatus.code === ReportStatusCode.ERROR ||
                                insightsStatus.code === ReportStatusCode.NO_DATA ||
                                (insightsStatus.code === ReportStatusCode.NOT_READY && (
                                    <div className="message-wrapper">{insightsStatus.message}</div>
                                ))}
                        </Tabs.TabPane>
                    )}
                </Tabs>
            </div>
        </div>
    )
}
